import React, { useState, useEffect } from 'react';
import { Row, Col, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Axios from 'axios';
import { ConsultaAPI } from '../../../../shared/http-requests';
import { changeSearchOptions } from '../../../../store/ducks/pesquisa';
import { Store } from '../../../../store';
import { StringHelper } from '../../../../shared/helpers';
import i18next from 'i18next';
import { useAccessibilityContext } from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import Button from '../../../consulta-acessibilidade/Button';

const PesquisaArquivo = props => {
    const { t } = useTranslation();
    const [opcoes, setOpcoes] = useState([]);
    const { searchInputRef } = useAccessibilityContext();

    //? Valores dentro do select de condicoes:
    const condicoes = [
        { label: t('AND'), value: 'AND', intermediario: false },
        { label: t('OR'), value: 'OR', intermediario: false },
        { label: t('NOT'), value: 'NOT', intermediario: false },
        { label: t('AFT'), value: 'AFT', intermediario: true },
        { label: t('BEF'), value: 'BEF', intermediario: true },
    ];

    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        ConsultaAPI.buscarOpcoesArquivo(cancelToken.token)
            .then(response => {
                setOpcoes(response.data);
                response.data.forEach(d => {
                    //Coloca as descrições da combo na internacionalização para ser utilizado em outras labels da aplicação.
                    i18next.addResource(
                        'pt',
                        'translation',
                        d.codigo,
                        d.descricao,
                    );
                    i18next.addResource(
                        'en',
                        'translation',
                        d.codigo,
                        d.descricao,
                    );
                    i18next.addResource(
                        'es',
                        'translation',
                        d.codigo,
                        d.descricao,
                    );
                });
            })
            .catch(error => {
                if (!Axios.isCancel(error)) return;
            });
        //? cleanup
        return () => cancelToken.cancel();
    }, []);

    const handleChangeComboTermo = (e, index) => {
        e.preventDefault();
        let valor = e.target.value;
        let optPesquisa = props.opcoesConsulta;
        optPesquisa[index].option = valor;

        if (['AFT', 'BEF'].includes(optPesquisa[index].condition)) {
            optPesquisa[index + 1].option = valor;
        }
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const handleChangeTextTermo = (e, index) => {
        e.preventDefault();
        let valor = e.target.value;
        let optPesquisa = props.opcoesConsulta;
        optPesquisa[index].termo = valor;
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const handleChangeComboCondicao = (e, index) => {
        e.preventDefault();
        let valor = e.target.value;
        let optPesquisa = props.opcoesConsulta;
        optPesquisa[index].condition = valor;

        if (['AFT', 'BEF'].includes(valor)) {
            optPesquisa[index + 1].option = optPesquisa[index].option;
        }
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const adicionarTermoPesquisa = () => {
        let optPesquisa = props.opcoesConsulta;
        optPesquisa.push({ option: 'obra', termo: '' });
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const removerTermoPesquisa = index => {
        let optPesquisa = props.opcoesConsulta;
        if (!optPesquisa[index + 1]) {
            optPesquisa[index - 1].condition = undefined;
        }
        optPesquisa.splice(index, 1);
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const getCondicoes = indexLinha => {
        /*PRIMEIRA LINHA*/
        if (indexLinha === 0 && props.opcoesConsulta.length < 3) {
            return condicoes.map(condicao => (
                <option key={`cond-${condicao.value}`} value={condicao.value}>
                    {condicao.label}
                </option>
            ));
        } else {
            return condicoes
                .filter(c => !c.intermediario)
                .map(condicao => (
                    <option
                        key={`cond-${condicao.value}`}
                        value={condicao.value}
                    >
                        {condicao.label}
                    </option>
                ));
        }
    };

    return (
        <Row>
            <Col md="10" xs="12">
                {props.opcoesConsulta &&
                    props.opcoesConsulta.map((opcao, index) => (
                        <Row className="content__left__input px-3 pt-1 pb-0"
                            
                            key={`row-termo-${index}`}
                        >
                            <Col
                                sm="1"
                                xs="12"
                                className="input-holder mt-3 text-sm-right text-center"
                            >
                                {(index === 1 || index === 2) && (
                                    <div>
                                        <button
                                            className="btn-generic--primeiro nao ml-2 d-sm-inline-block d-none mt-3"
                                            title={t('Remover')}
                                            type="button"
                                            onClick={() =>
                                                removerTermoPesquisa(index)
                                            }
                                        >
                                            <FontAwesomeIcon icon="times" />
                                        </button>
                                        <button
                                            style={{ marginTop: '-30px' }}
                                            className="btn-generic--primeiro nao ml-2 mt-0 d-sm-none d-block"
                                            type="button"
                                            onClick={() =>
                                                removerTermoPesquisa(index)
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon="times"
                                                className="s18 r5"
                                            />
                                            <span className="s14">
                                                {' '}
                                                {t('Remover')}{' '}
                                            </span>
                                        </button>
                                    </div>
                                )}
                            </Col>
                            <Col sm="2" xs="12" className="input-holder mt-3">
                                <div className='rotulo'>
                                    {t('TipoPesquisas')}
                                </div>
                                <Input
                                    type="select"
                                    name={`for${index === 0 ? '' : index + 1}`}
                                    value={opcao.option}
                                    onChange={e =>
                                        handleChangeComboTermo(e, index)
                                    }
                                    disabled={
                                        index > 0 &&
                                        ['AFT', 'BEF'].includes(
                                            props.opcoesConsulta[0].condition,
                                        )
                                    }
                                >
                                    {opcoes.map(termo => (
                                        <option
                                            key={`opt-arquivo-${termo.codigo}`}
                                            value={termo.codigo}
                                        >
                                            {termo.descricao}
                                        </option>
                                    ))}
                                </Input>
                                <div className="invalid-feedback">
                                    {t('CampoBuscaObrigatorio')}
                                </div>
                            </Col>
                            <Col sm="6" xs="12" className="input-holder mt-3">
                                <div className='rotulo'>
                                    {t('CampoBusca')}
                                </div>
                                <Input
                                    innerRef={searchInputRef}
                                    type="text"
                                    className='foco'
                                    name={`q${index === 0 ? '' : index + 1}`}
                                    placeholder={t('DigiteSuaBuscaAqui')}
                                    invalid={
                                        props.error &&
                                        StringHelper.isBlank(opcao.termo)
                                    }
                                    value={opcao.termo || ''}
                                    onChange={e =>
                                        handleChangeTextTermo(e, index)
                                    }
                                />
                                <div className="invalid-feedback">
                                    {t('CampoBuscaObrigatorio')}
                                </div>
                            </Col>
                            <Col sm="3" xs="12" className="mt-3 input-holder align-self-end ">
                                {index < 2 &&
                                    (index ===
                                    props.opcoesConsulta.length - 1 ? (
                                        //? Não adicionar a terceira linha se a primeira for um dos condicionais (anterior, depois)
                                        !['AFT', 'BEF'].includes(
                                            props.opcoesConsulta[0].condition,
                                        ) && (
                                            <div className="d-inline-block">
                                                <button
                                                    type="button"
                                                    className="btn-generic--segundo ml-0"
                                                    onClick={() =>
                                                        adicionarTermoPesquisa()
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon="plus"
                                                        className="mr-2"
                                                    />{' '}
                                                    {t('AdicionarTermo')}
                                                </button>
                                            </div>
                                        )
                                    ) : (
                                        <>
                                            <div className='rotulo'>
                                                {t('Condicionais')}
                                            </div>
                                            <Input
                                                type="select"
                                                invalid={
                                                    props.error &&
                                                    StringHelper.isBlank(
                                                        opcao.condition,
                                                    )
                                                }
                                                style={{
                                                    width: '70%',
                                                    display: 'inline',
                                                }}
                                                name={`condition${
                                                    index === 0 ? '' : index + 1
                                                }`}
                                                value={opcao.condition || '-1'}
                                                onChange={e =>
                                                    handleChangeComboCondicao(
                                                        e,
                                                        index,
                                                    )
                                                }
                                            >
                                                <option
                                                    value="-1"
                                                    disabled
                                                ></option>
                                                {getCondicoes(index)}
                                            </Input>
                                            <div className="invalid-feedback">
                                                {t('CampoBuscaObrigatorio')}
                                            </div>
                                        </>
                                    ))}
                            </Col>
                        </Row>
                    ))}
            </Col>
            <Col
                md="2"
                xs="12"
                className={classnames(' mt-3 px-3 align-self-end pb-0', { 'mb-4': props.error })}
            >
                <Button
                    title="Pesquisar"
                    icon="search"
                    variant='primeiro ml-0 btn-responsivo'
                    type="submit"
                    disabled={props.loading}
                />
            </Col>
        </Row>
    );
};

export default PesquisaArquivo;
